import { HOW_IT_WORKS } from "@/lib/content";
import { Reveal } from "@/components/common/Reveal";

export const HowItWorks = () => (
  <section className="border-t border-border bg-navy py-24 text-white lg:py-32" data-testid="how-scc-works">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal className="max-w-2xl">
        <h2 className="font-heading text-3xl font-extrabold tracking-tight md:text-4xl lg:text-5xl">
          How SCC works
        </h2>
        <p className="mt-5 text-lg leading-relaxed text-slate-300">
          A problem-first process, deliberate at every step.
        </p>
      </Reveal>

      <div className="mt-16 grid gap-x-12 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
        {HOW_IT_WORKS.map((step, i) => (
          <Reveal key={step.index} delay={i * 0.06} className="border-t border-white/20 pt-5">
            <span className="text-sm font-semibold text-blue-400">{step.index}</span>
            <h3 className="mt-2 font-heading text-lg font-bold text-white">{step.title}</h3>
            <p className="mt-2 text-[15px] leading-relaxed text-slate-400">{step.body}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
